// Mock data for Dirpusdadig PPI Dunia Landing Page

export const heroData = {
  headline: "Akselerasi Digital Pelajar Indonesia Mendunia",
  subheadline: "Layanan infrastruktur teknologi dan data terintegrasi untuk PPI Negara, Kawasan, dan Badan Kelengkapan.",
  primaryCTA: "Ajukan Layanan",
  secondaryCTA: "Konsultasi Teknis"
};

export const servicesData = [
  {
    id: 1,
    icon: "Palette",
    logo: "/logo-canva.png",
    title: "Canva Team Pro Access",
    description: "Akses admin penuh untuk tiap PPI Negara. Undang pengurus ke tim, namun desain tetap privat di akun masing-masing.",
    detailTitle: "Canva Team Pro untuk PPI",
    details: [
      {
        subtitle: "Apa yang Anda Dapatkan?",
        content: "Akses penuh ke Canva Pro dengan fitur tim yang memungkinkan kolaborasi antar pengurus PPI. Setiap PPI Negara mendapatkan akses admin untuk mengelola tim mereka sendiri."
      },
      {
        subtitle: "Fitur Unggulan",
        content: "• Brand Kit untuk konsistensi desain organisasi\n• 100+ juta template premium\n• Background Remover otomatis\n• Magic Resize untuk berbagai platform\n• Folder tim terorganisir"
      },
      {
        subtitle: "Kebijakan Privasi",
        content: "Semua desain yang dibuat tetap menjadi milik pribadi masing-masing pengguna. Tim admin tidak dapat mengakses desain personal Anda."
      }
    ],
    guideTitle: "Panduan Pengajuan",
    guides: [
      {
        image: "/guide-canva-1.png",
        caption: "1. Buka tautan canva.ppi.or.id dan login by Google untuk memudahkan proses pengisian data dan keamanannya."
      },
      {
        image: "/guide-canva-2.png",
        caption: "2. Setelah berhasil, silakan isi data PIC, asal PPI Negara, estimasi jumlah mahasiswa di negara tersebut, dan email yang akan dijadikan admin Canva Team. Disarankan mengajukan email resmi @ppi.id untuk fitur-fitur lainnya."
      },
      {
        image: "/guide-canva-3.png",
        caption: "3. Jika mengajukan email, isi username yang diinginkan, lalu submit dan tunggu approval Dirpusdadig."
      }
    ],
    gradient: "from-cyan-50 to-teal-50",
    bgColor: "cyan",
    actionLink: "https://canva.ppi.or.id"
  },
  {
    id: 2,
    icon: "Mail",
    logo: null,
    title: "Professional Domain (@ppi.id)",
    description: "Tingkatkan kredibilitas dengan email resmi (contoh: jepang@ppi.id). Amankan aset organisasi dan 'Institutional Memory' di Shared Drive, bukan drive pribadi.",
    detailTitle: "Google Workspace untuk PPI",
    details: [
      {
        subtitle: "Mengapa Email @ppi.id?",
        content: "Email dengan domain @ppi.id meningkatkan kredibilitas saat berkomunikasi dengan sponsor, institusi pendidikan, dan pihak eksternal lainnya."
      },
      {
        subtitle: "Fitur Google Workspace",
        content: "• Email profesional (contoh: jepang@ppi.id)\n• Google Drive 30GB per pengguna (dapat ditingkatkan sesuai permintaan)\n• Shared Drive untuk aset organisasi\n• Google Calendar untuk koordinasi\n• Google Docs, Sheets, Slides"
      },
      {
        subtitle: "Institutional Memory",
        content: "Dengan Shared Drive, semua dokumen penting organisasi tersimpan aman dan tidak hilang saat pengurus berganti. Data tetap menjadi milik organisasi, bukan individu."
      },
      {
        subtitle: "Persyaratan",
        content: "• PPI Negara yang terdaftar resmi\n• Komitmen penggunaan sesuai kebijakan"
      }
    ],
    gradient: "from-blue-50 to-indigo-50",
    bgColor: "blue"
  },
  {
    id: 3,
    icon: "Video",
    logo: null,
    title: "Zoom Discount 50%",
    description: "Solusi hemat biaya untuk rapat kerja dan webinar organisasi. Fasilitas premium dengan harga khusus pelajar.",
    detailTitle: "Zoom Premium dengan Harga Khusus",
    details: [
      {
        subtitle: "Penawaran Eksklusif",
        content: "Dapatkan diskon hingga 50% untuk lisensi Zoom Pro dan Zoom Business melalui program Zoom for Nonprofit."
      },
      {
        subtitle: "Paket Tersedia",
        content: "• Zoom Pro: Rapat hingga 30 jam, 100 peserta\n• Zoom Business: 300 peserta, recording cloud\n• Zoom Webinar: Hingga 1000 peserta\n• Add-on: Large Meeting, Cloud Storage"
      },
      {
        subtitle: "Keuntungan",
        content: "• Hemat hingga 50% dari harga normal\n• Support teknis dari tim Dirpusdadig\n• Pelatihan penggunaan fitur lanjutan"
      }
    ],
    guideTitle: "Panduan Pendaftaran",
    guides: [
      {
        image: "/guide-zoom-1.png",
        caption: "1. Akses s.ppi.id/zoom50, lalu klik tombol biru \"$10 million or less\" untuk memulai proses pendaftaran."
      },
      {
        image: "/guide-zoom-2.png",
        caption: "2. Anda akan diarahkan ke halaman verifikasi organisasi. Pilih \"Indonesia\" sebagai negara asal."
      },
      {
        image: "/guide-zoom-3.png",
        caption: "3. Pada kolom nama organisasi, masukkan \"Perkumpulan Pelajar Indonesia Sedunia\" secara lengkap."
      },
      {
        image: "/guide-zoom-4.png",
        caption: "4. Masukkan nama lengkap Anda sebagai penanggung jawab pendaftaran."
      },
      {
        image: "/guide-zoom-5.png",
        caption: "5. Gunakan email dengan domain @ppi.id milik PPI Negara Anda untuk verifikasi instan. Setujui persyaratan, kirim aplikasi, dan tunggu email konfirmasi!"
      },
      {
        image: "/guide-zoom-6.png",
        caption: "6. Setelah permintaan diterima, Anda akan mendapatkan link khusus untuk melanjutkan langganan tahunan dengan harga diskon. Ikuti instruksi yang diberikan!"
      }
    ],
    gradient: "from-sky-50 to-blue-50",
    bgColor: "sky",
    actionLink: "https://s.ppi.id/zoom50"
  },
  {
    id: 4,
    icon: "Globe",
    logo: null,
    title: "Web Hosting & Subdomain",
    description: "Belum punya website? Kami sediakan hosting dan diskusi teknis untuk membangun wajah digital organisasi Anda.",
    detailTitle: "Layanan Web Hosting PPI",
    details: [
      {
        subtitle: "Subdomain Gratis",
        content: "Dapatkan subdomain gratis seperti jepang.ppi.id atau korea.ppi.id untuk website resmi PPI Negara Anda."
      },
      {
        subtitle: "Dukungan Teknis",
        content: "• Konsultasi pemilihan platform (WordPress, dll)\n• Bantuan setup awal\n• Tutorial pengelolaan website\n• Troubleshooting teknis\n• Migrasi dari hosting lama"
      },
      {
        subtitle: "Persyaratan",
        content: "• PPI Negara terdaftar\n• Tim pengelola website (minimal 1 orang)\n• Konten website sesuai visi misi PPI\n• Tidak melanggar hukum Indonesia"
      }
    ],
    gradient: "from-emerald-50 to-green-50",
    bgColor: "emerald"
  },
  {
    id: 5,
    icon: "Send",
    logo: "/logo-gmail.png",
    title: "Email Broadcaster",
    description: "Kirim undangan atau proposal sponsorship ke ratusan penerima melalui CSV/XLS. Konten dinamis dan personal untuk setiap penerima.",
    detailTitle: "Email Broadcaster untuk Kampanye",
    details: [
      {
        subtitle: "Apa Itu Email Broadcaster?",
        content: "Layanan pengiriman surel massal yang memungkinkan Anda mengirim undangan, proposal sponsorship, atau buletin ke ratusan penerima sekaligus dengan personalisasi otomatis."
      },
      {
        subtitle: "Fitur Utama",
        content: "• Unggah daftar penerima melalui CSV/XLS\n• Templat surel HTML responsif\n• Mail merge untuk personalisasi\n• Penjadwalan pengiriman"
      },
      {
        subtitle: "Contoh Penggunaan",
        content: "• Undangan acara ke seluruh pelajar\n• Proposal sponsorship ke perusahaan\n• Buletin bulanan PPI\n• Pengumuman beasiswa\n• Koordinasi antara PPI"
      },
      {
        subtitle: "Kuota dan Batasan",
        content: "Kuota pengiriman surel sesuai dengan akun masing-masing. Tidak untuk spam atau promosi komersial."
      }
    ],
    guideTitle: "Panduan Penggunaan",
    guides: [
      {
        image: "/guide-email-1.png",
        caption: "1. Buka gema.ppi.or.id dan masuk dengan akun Google. Sangat disarankan menggunakan surel @ppi.id agar proses berjalan lancar."
      },
      {
        image: "/guide-email-2.png",
        caption: "2. Setelah masuk, pelajari panduan lengkap di menu \"Panduan\" untuk memahami fitur-fitur yang tersedia."
      },
      {
        image: "/guide-email-3.png",
        caption: "3. Sebelum melakukan siaran, tambahkan daftar penerima terlebih dahulu beserta data yang ingin dikirimkan seperti nama, perusahaan, jabatan, tautan sertifikat, dan sebagainya sesuai isi siaran."
      },
      {
        image: "/guide-email-4.png",
        caption: "4. Tuliskan nama segmen kontak untuk mengelompokkan penerima berdasarkan kategori tertentu."
      },
      {
        image: "/guide-email-5.png",
        caption: "5. Siapkan berkas Excel berisi data penerima dengan detail lainnya, lalu simpan dalam format CSV untuk diunggah ke sistem."
      },
      {
        image: "/guide-email-6.png",
        caption: "6. Petakan kolom mana yang merupakan alamat surel, nama depan, dan nama belakang. Kolom lainnya akan menjadi variabel khusus yang dapat digunakan saat siaran dengan mengetik {{nama_kolom}}."
      },
      {
        image: "/guide-email-7.png",
        caption: "7. Periksa kembali hasil impor untuk memastikan tidak ada kesalahan data sebelum melanjutkan."
      },
      {
        image: "/guide-email-8.png",
        caption: "8. Mulai buat kampanye atau konten siaran baru sesuai kebutuhan Anda."
      },
      {
        image: "/guide-email-9.png",
        caption: "9. Anda dapat mengirim siaran secara langsung atau menjadwalkannya untuk waktu mendatang."
      },
      {
        image: "/guide-email-10.png",
        caption: "10. Jika status masih DRAF, klik ikon pesawat untuk mengirimkan siaran ke seluruh penerima."
      }
    ],
    gradient: "from-red-50 to-orange-50",
    bgColor: "red",
    actionLink: "https://gema.ppi.or.id"
  },
  {
    id: 6,
    icon: "MessageSquare",
    logo: null,
    title: "WAFORM (WhatsApp Form)",
    description: "Formulir digital terintegrasi WhatsApp. Isi data semudah membalas chat, respons terkapitulasi otomatis.",
    detailTitle: "WAFORM - Form via WhatsApp",
    details: [
      {
        subtitle: "Konsep WAFORM",
        content: "WAFORM adalah inovasi pengisian formulir melalui WhatsApp. Responden tidak perlu membuka link form, cukup balas chat dengan format yang sudah ditentukan."
      },
      {
        subtitle: "Keunggulan",
        content: "• Tingkat respons lebih tinggi (via WA)\n• Tidak perlu install aplikasi\n• Data otomatis terkapitulasi\n• Export ke Excel/Google Sheets\n• Reminder otomatis"
      },
      {
        subtitle: "Use Case",
        content: "• Pendaftaran acara\n• Survey kepuasan\n• Pendataan anggota\n• RSVP kegiatan\n• Polling dan voting\n• Pengumpulan data kontak"
      },
      {
        subtitle: "Cara Menggunakan",
        content: "1. Buat form di dashboard WAFORM\n2. Generate link/QR code\n3. Bagikan ke grup WhatsApp\n4. Responden balas sesuai format\n5. Data otomatis masuk dashboard"
      }
    ],
    gradient: "from-green-50 to-emerald-50",
    bgColor: "green",
    actionLink: "https://waform.ppi.or.id"
  }
];

export const ctaData = {
  text: "Siap mendigitalkan PPI Negara Anda?",
  button: "Hubungi Tim Dirpusdadig"
};

export const footerData = {
  copyright: "© 2026 Dirpusdadig PPI Dunia"
};
